import { createAction } from 'typesafe-actions';

export const UPDATE_SUPERADMIN = 'superAdmin/UPDATE_SUPERADMIN';

export const getSuperAdminAsync = createAction(UPDATE_SUPERADMIN, ({ ...parameters }) => ({ ...parameters }))()


